import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=6c0e54d3&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0e54d3')) {
      api.createRecord('6c0e54d3', component.options)
    } else {
      api.reload('6c0e54d3', component.options)
    }
    module.hot.accept("./Page.vue?vue&type=template&id=6c0e54d3&", function () {
      api.rerender('6c0e54d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Page.vue"
export default component.exports